
export const PendingEligibilityMessage = 'Eligibilité en cours de revue';
